import styled, {css} from "styled-components"

import {spacingCss, SpacingProps} from "@irati/ui/src/global/css"
import Flex from "@irati/ui/src/Flex"
import {Label} from "@irati/ui/src/Typography"
import {hoverRaise} from "@irati/ui/src/global/css/animations"
import {IconButton} from "@irati/ui/src/Button"

interface VideoProps extends SpacingProps {
  thumbnail: string
  slidesToShow: number
}

interface StyledProps {
  inProgress?: boolean
  reminderEnabled?: boolean
}

export const VideoCardWrapper = styled.div`
  ${({theme}) => css`
    position: relative;
    padding-bottom: 56.2%;
    margin-bottom: ${theme.spacing.oneAndHalf};
  `}
`

export const VideoCardBackground = styled.div<VideoProps>`
  ${({theme, thumbnail}) => css`
    position: absolute;
    width: 97%;
    height: 100%;
    background-image: url("${thumbnail}");
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;
    border-radius: ${theme.border.radius.large};
    overflow: hidden;
    padding: ${theme.spacing.one};
    ${theme.mediaQueries.minWidthMedia.tablet`
      padding: ${theme.spacing.two};
    `}
    ${hoverRaise}
  `}

  ${spacingCss}
`

export const TopShadow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 20%;
  width: 100%;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
`
export const BottomShadow = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 50%;
  width: 100%;
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
`

export const BottomDetailsContainer = styled(Flex)`
  ${({theme}) => css`
    margin: 0 0 ${theme.spacing.one} ${theme.spacing.one};
    z-index: 1;
    ${theme.mediaQueries.minWidthMedia.tablet`
      margin: 0 0 ${theme.spacing.two} ${theme.spacing.two};
    `}
  `}
`

export const TopDetailsLiveVideoContainer = styled(Flex)`
  z-index: 1;
`

export const BottomDetailsLiveVideoContainer = styled(Flex)`
  ${({theme}) => css`
    margin: 0;
    z-index: 1;
    ${theme.mediaQueries.minWidthMedia.tablet`
      margin: 0;
    `}
  `}
`

export const StyledLabel = styled(Label)<StyledProps>`
  ${({inProgress, theme}) => css`
    font-family: ${theme.font.bold};
    border-radius: ${theme.spacing.three};
    background-color: ${inProgress ? theme.colors.primary1 : "#00C9C2"};
    color: ${theme.colors.utility.white};
    padding: 6px ${theme.spacing.four};
    text-align: center;
  `}
`

export const NotificationsEnabledStatusLabel = styled(Label)<StyledProps>`
  ${({reminderEnabled, theme}) => css`
    font-family: ${theme.font.bold};
    border-radius: ${theme.spacing.three};
    background-color: ${reminderEnabled ? "#ACD4D3" : "#00C9C2"};
    color: ${theme.colors.utility.white};
    padding: 6px ${theme.spacing.four};
    text-align: center;
  `}
`

export const Image = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 50%;
`

export const StyledIcon = styled(IconButton)`
  ${({theme}) => css`
    position: absolute;
    top: ${theme.spacing.oneAndHalf};
    right: ${theme.spacing.oneAndHalf};
    z-index: 9999;
    svg g path {
      fill: ${theme.colors.greys.white};
    }
  `}
`
